import { EnumTypeValue } from "@/shared/types";

export const LogboekItemBron = {
    SPOORWEB: "Spoorweb",
    RCB: "Regiecentrum Bus",
    REGIEVOERDER: "Regievoerder",
    KLANTENSERVICE: "Klantenservice",
} as const;

export type LogboekItemBron = EnumTypeValue<typeof LogboekItemBron>;

export const LOGBOEK_QUERY_KEY = "logboek";
